<template>
    <RadioGroup v-model="selected" class="mt-2 md:mt-0 md:ml-6">
        <div
            v-if="disabled"
            class="z-20 inset-0 bg-white/50 absolute transition-all"
        ></div>
        <RadioGroupLabel
            class="block text-sm font-bold text-gray-700"
            :class="{ 'block md:hidden': (index > 0 && mks) || wizard }"
        >
            <InfoModal title="Kleur" :infoIcon="true" :body="info">Kleur</InfoModal>
        </RadioGroupLabel>
        <div class="space-x-2 flex pt-5 items-center">
            <RadioGroupOption
                as="div"
                v-for="color in options"
                :key="color.id"
                :value="color"
                v-slot="{ active, checked }"
                @click="$emit('update:value', color)"
            >
                <div
                    :class="[
                        active && checked ? 'ring-3' : '',
                        !active && checked ? 'ring-2' : '',
                        color.id == cylinder.color.id ? 'ring-offset-1 ring-2' : '',
                        'ring-dgreen -m-0.5 relative p-0.5 ring-offset-1 rounded-full flex items-center justify-center cursor-pointer focus:outline-hidden',
                    ]"
                >
                    <RadioGroupLabel as="p" class="sr-only">{{ color.name }}</RadioGroupLabel>
                    <span
                        aria-hidden="true"
                        :class="[background(color), 'h-6 w-6 border border-black/10 rounded-full']"
                    />
                </div>
            </RadioGroupOption>
        </div>
    </RadioGroup>
</template>

<script>
import { ref } from 'vue';

export default {
    props: {
        options: Array,
        value: Object | Boolean,
        info: String,
        index: Number,
        cylinder: Object,
        mks: Boolean,
        wizard: Boolean,
        disabled: Boolean,
    },

    setup(props) {
        function background(color) {
            if (color.value == 'Nikkel') {
                return 'bg-gray-300';
            }
            if (color.value == 'Messing') {
                return 'bg-messing';
            }
            if (color.value == 'Zwart') {
                return 'bg-black';
            }
        }

        const selected = ref(props.value != false ? props.value : props.options[0]);

        return { selected, background };
    },
};
</script>
